import { createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bf0af694")

_pushScopeId("data-v-bf0af694")
const _hoisted_1 = { class: "col" }
const _hoisted_2 = {
  key: 0,
  class: "card col-md-12 tarjeta-comentarios",
  style: {"border-style":"none"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("label", null, "Acciones de la solicitud")
], -1)
const _hoisted_4 = { class: "card-body col-md-12 overflow-auto" }
const _hoisted_5 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "Elige una opcion", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Autorizar", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: "6" }, "Rechazar", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("option", { value: "5" }, "Aclaracion", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header\" data-v-bf0af694><label data-v-bf0af694>Horarios de Recepción CxP</label></div><div class=\"text2\" data-v-bf0af694><text data-v-bf0af694>Se programa el pago para el día siguiente hábil</text></div><div class=\"text\" data-v-bf0af694><text data-v-bf0af694>Lunes a Jueves                           9:00 a 15:15hrs</text><br data-v-bf0af694><text data-v-bf0af694>Viernes                                       9:00 a 13:00hrs</text><br data-v-bf0af694><text data-v-bf0af694>Días de trabajo medio día         9:00 a 12:15hrs</text></div><div class=\"text2\" data-v-bf0af694><br data-v-bf0af694><text data-v-bf0af694>Después de estos horarios el pago será programado</text><text data-v-bf0af694> al tercer día hábil a partir de la recepción del mismo.</text></div>", 4)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = {
  class: "card-footer col-md-12",
  style: {"background-color":"white"}
}
const _hoisted_16 = {
  key: 1,
  class: "card col-md-12 tarjeta-comentarios",
  style: {"border-style":"none"}
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("label", null, "Acciones de la solicitud")
], -1)
const _hoisted_18 = { class: "card-body col-md-12 overflow-auto" }
const _hoisted_19 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "Elige una opcion", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Verificado", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("option", { value: "6" }, "Rechazar", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("option", { value: "5" }, "Aclaracion", -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createVNode("h5", { class: "text-primary text-a" }, "Autorizador de área", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("label", {
  for: "fechapropuesta",
  class: "form-label"
}, null, -1)
const _hoisted_26 = { class: "input-group input-group mb-3" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { class: "input-group-text" }, "Enviar a:", -1)
const _hoisted_28 = {
  class: "card-footer col-md-12",
  style: {"background-color":"white"}
}
const _hoisted_29 = {
  key: 2,
  class: "card col-md-12 tarjeta-comentarios",
  style: {"border-style":"none"}
}
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("label", null, "Acciones de la solicitud")
], -1)
const _hoisted_31 = { class: "card-body col-md-12 overflow-auto" }
const _hoisted_32 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "Elige una opcion", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("option", { value: "3" }, "Verificado", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("option", { value: "6" }, "Rechazar", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("option", { value: "5" }, "Aclaracion", -1)
const _hoisted_36 = {
  class: "card-footer col-md-12",
  style: {"background-color":"white"}
}
const _hoisted_37 = {
  key: 3,
  class: "card col-md-12 tarjeta-comentarios",
  style: {"border-style":"none"}
}
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("label", null, "Acciones de la solicitud")
], -1)
const _hoisted_39 = { class: "card-body col-md-12 overflow-auto" }
const _hoisted_40 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "Elige una opcion", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("option", { value: "4" }, "Autorizar pago", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("option", { value: "6" }, "Rechazar", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("option", { value: "5" }, "Aclaracion", -1)
const _hoisted_44 = {
  class: "card-footer col-md-12",
  style: {"background-color":"white"}
}
const _hoisted_45 = {
  key: 4,
  class: "card col-md-12 tarjeta-comentarios",
  style: {"border-style":"none"}
}
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("label", null, "Acciones de la solicitud")
], -1)
const _hoisted_47 = { class: "card-body col-md-12 overflow-auto" }
const _hoisted_48 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "Elige una opcion", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("option", { value: "7" }, "Pago Realizado", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("option", { value: "8" }, "Pago Rechazado", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("p", null, "Insertar comprobante:", -1)
const _hoisted_53 = { class: "row contenedor-Documentos" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-upload" })
], -1)
const _hoisted_55 = { class: "textoDrag" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Arrastra aquí tus archivos o ")
const _hoisted_57 = { class: "custom-file" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "invalid-feedback" }, "Coloca al menos un PDF", -1)
const _hoisted_59 = { class: "col-md-6 area-lista-archivos" }
const _hoisted_60 = {
  key: 0,
  class: "text-center mt-5"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf iconoArchivo" }, null, -1)
const _hoisted_62 = { key: 1 }
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf iconoArchivo" }, null, -1)
const _hoisted_64 = {
  class: "card-footer col-md-12",
  style: {"background-color":"white"}
}
const _hoisted_65 = {
  class: "card col-md-12 tarjeta-comentarios mt-2",
  style: {"border-style":"none"}
}
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("label", null, "Comentarios")
], -1)
const _hoisted_67 = {
  class: "card-body col-md-12 overflow-auto",
  style: {"height":"300px","overflow-y":"scroll"}
}
const _hoisted_68 = { class: "fw-bold" }
const _hoisted_69 = {
  class: "fw-normal",
  style: {"color":"#1d2668"}
}
const _hoisted_70 = {
  class: "col-md-12",
  style: {"margin-top":"-0.5rem"}
}
const _hoisted_71 = { style: {"color":"#4f4f4f","margin-bottom":"-0.1rem"} }
const _hoisted_72 = { style: {"color":"#828282"} }
const _hoisted_73 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_74 = {
  class: "card-footer col-md-12",
  style: {"background-color":"white"}
}
const _hoisted_75 = /*#__PURE__*/_createVNode("i", { class: "fas fa-comment-dots" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Comentar ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ModalDocumento = _resolveComponent("ModalDocumento")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.rolUsuario.indexOf('Autoriza') == 0 && _ctx.estatusRequisicionId == 'EN_AUTORIZACION')
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.estatusRequisicion = $event)),
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.MostrarSelector && _ctx.MostrarSelector(...args))),
              class: "form-select",
              required: ""
            }, [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ], 544), [
              [_vModelSelect, _ctx.estatusRequisicion]
            ])
          ]),
          (_ctx.estatusRequisicion == 2)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _hoisted_10
              ]))
            : _createCommentVNode("", true),
          _hoisted_14,
          _createVNode("div", _hoisted_15, [
            _withDirectives(_createVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.observaciones = $event)),
              class: "form-control area-motivo",
              id: "exampleFormControlMotivo",
              rows: "3",
              placeholder: "Escribe tu motivo"
            }, null, 512), [
              [_vModelText, _ctx.observaciones]
            ]),
            _createVNode("button", {
              type: "submit",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.ActualizarEstatus()), ["prevent"])),
              class: "btn btn-primary float-end mt-2",
              style: {"color":"white","border-radius":"7px"},
              id: "btn-Enviar"
            }, " Responder ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.rolUsuario.indexOf('Verifica') == 0 && _ctx.estatusRequisicionId == 'EN_VERIFICACION_AREA')
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _hoisted_17,
          _createVNode("div", _hoisted_18, [
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.estatusRequisicion = $event)),
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.MostrarSelector && _ctx.MostrarSelector(...args))),
              class: "form-select",
              required: ""
            }, [
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22
            ], 544), [
              [_vModelSelect, _ctx.estatusRequisicion]
            ])
          ]),
          (_ctx.estatusRequisicion == 1)
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                _hoisted_24,
                _hoisted_25,
                _createVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.autorizadorId = $event)),
                    required: ""
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.Autorizadores, (autorizador) => {
                      return (_openBlock(), _createBlock("option", {
                        key: autorizador.id,
                        value: autorizador.id
                      }, _toDisplayString(autorizador.normalizedUserName), 9, ["value"]))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.autorizadorId]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_28, [
            _withDirectives(_createVNode("textarea", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.observaciones = $event)),
              class: "form-control area-motivo",
              id: "exampleFormControlMotivo",
              rows: "3",
              placeholder: "Escribe tu motivo"
            }, null, 512), [
              [_vModelText, _ctx.observaciones]
            ]),
            _createVNode("button", {
              type: "submit",
              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.ActualizarEstatus()), ["prevent"])),
              class: "btn btn-primary float-end mt-2",
              style: {"color":"white","border-radius":"7px"},
              id: "btn-Enviar"
            }, " Responder ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.rolUsuario.indexOf('Verifica') == 0 && _ctx.estatusRequisicionId == 'EN_VALIDACION_CXP')
      ? (_openBlock(), _createBlock("div", _hoisted_29, [
          _hoisted_30,
          _createVNode("div", _hoisted_31, [
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.estatusRequisicion = $event)),
              onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.MostrarSelector && _ctx.MostrarSelector(...args))),
              class: "form-select",
              required: ""
            }, [
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35
            ], 544), [
              [_vModelSelect, _ctx.estatusRequisicion]
            ])
          ]),
          _createVNode("div", _hoisted_36, [
            _withDirectives(_createVNode("textarea", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.observaciones = $event)),
              class: "form-control area-motivo",
              id: "exampleFormControlMotivo",
              rows: "3",
              placeholder: "Escribe tu motivo"
            }, null, 512), [
              [_vModelText, _ctx.observaciones]
            ]),
            _createVNode("button", {
              type: "submit",
              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.ActualizarEstatus()), ["prevent"])),
              class: "btn btn-primary float-end mt-2",
              style: {"color":"white","border-radius":"7px"},
              id: "btn-Enviar"
            }, " Responder ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.rolUsuario.indexOf('Autorizador CXP') == 0 && _ctx.estatusRequisicionId == 'EN_AUTORIZACION_CXP')
      ? (_openBlock(), _createBlock("div", _hoisted_37, [
          _hoisted_38,
          _createVNode("div", _hoisted_39, [
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.estatusRequisicion = $event)),
              onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.MostrarSelector && _ctx.MostrarSelector(...args))),
              class: "form-select",
              required: ""
            }, [
              _hoisted_40,
              _hoisted_41,
              _hoisted_42,
              _hoisted_43
            ], 544), [
              [_vModelSelect, _ctx.estatusRequisicion]
            ])
          ]),
          _createVNode("div", _hoisted_44, [
            _withDirectives(_createVNode("textarea", {
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.observaciones = $event)),
              class: "form-control area-motivo",
              id: "exampleFormControlMotivo",
              rows: "3",
              placeholder: "Escribe tu motivo"
            }, null, 512), [
              [_vModelText, _ctx.observaciones]
            ]),
            _createVNode("button", {
              type: "submit",
              onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.ActualizarEstatus()), ["prevent"])),
              class: "btn btn-primary float-end mt-2",
              style: {"color":"white","border-radius":"7px"},
              id: "btn-Enviar"
            }, " Responder ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.rolUsuario.indexOf('Tesoreria') == 0 && _ctx.estatusRequisicionId == 'EN_TESORERIA')
      ? (_openBlock(), _createBlock("div", _hoisted_45, [
          _hoisted_46,
          _createVNode("div", _hoisted_47, [
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.estatusRequisicion = $event)),
              onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.MostrarSelector && _ctx.MostrarSelector(...args))),
              class: "form-select",
              required: ""
            }, [
              _hoisted_48,
              _hoisted_49,
              _hoisted_50
            ], 544), [
              [_vModelSelect, _ctx.estatusRequisicion]
            ]),
            _hoisted_51,
            _hoisted_52,
            _createVNode("div", _hoisted_53, [
              _createVNode("div", {
                class: "col-md-6 area-drag",
                onDragover: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.DragArchivo && _ctx.DragArchivo(...args))),
                onDrop: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.DropArchivo && _ctx.DropArchivo(...args)))
              }, [
                _hoisted_54,
                _createVNode("span", _hoisted_55, [
                  _hoisted_56,
                  _createVNode("span", {
                    class: "buscarDrag",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.ClickAInput && _ctx.ClickAInput(...args)))
                  }, "Busca aquí tus archivos")
                ]),
                _createVNode("div", _hoisted_57, [
                  _withDirectives(_createVNode("input", {
                    ref: "inputArchivo",
                    type: "file",
                    multiple: "",
                    onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.SubirArchivo && _ctx.SubirArchivo(...args))),
                    class: "custom-file-input form form-control",
                    id: "validatedCustomFile",
                    accept: "application/pdf, text/xml",
                    required: ""
                  }, null, 544), [
                    [_vShow, false]
                  ]),
                  _hoisted_58
                ])
              ], 32),
              _createVNode("div", _hoisted_59, [
                (_ctx.archivosRequisicion <= 0 && _ctx.documentosExistentes <= 0)
                  ? (_openBlock(), _createBlock("p", _hoisted_60, " Aquí se mostraran los archivos que cargues. "))
                  : _createCommentVNode("", true),
                _createVNode("ul", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.archivosRequisicion, (archivo) => {
                    return (_openBlock(), _createBlock("li", {
                      class: "archivoSubido",
                      key: archivo.lastModified
                    }, [
                      _hoisted_61,
                      _createTextVNode(_toDisplayString(archivo.name) + " ", 1),
                      _createVNode("i", {
                        class: "fas fa-times iconoEliminarArchivo",
                        onClick: _withModifiers(($event: any) => (_ctx.EliminarArchivo(archivo.name)), ["prevent"])
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ]),
                (_ctx.requisicionIdExistente != null)
                  ? (_openBlock(), _createBlock("ul", _hoisted_62, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentosExistentes, (documento) => {
                        return (_openBlock(), _createBlock("li", {
                          class: "archivoSubido",
                          key: documento.documentoRequisicionPagoId
                        }, [
                          _hoisted_63,
                          (documento.tipoDocumento == 'PDF')
                            ? (_openBlock(), _createBlock("u", {
                                key: 0,
                                style: {"cursor":"pointer"},
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modalDocumento",
                                ref: "ligaModal",
                                onClick: ($event: any) => (_ctx.MostrarArchivo(documento.documentoRequisicionPagoId, documento.tipoDocumento))
                              }, _toDisplayString(documento.fechaSubida.substring(0, 10).toLowerCase()), 9, ["onClick"]))
                            : _createCommentVNode("", true),
                          (documento.tipoDocumento != 'PDF')
                            ? (_openBlock(), _createBlock("u", {
                                key: 1,
                                "data-bs-toggle": "modal",
                                style: {"cursor":"pointer"},
                                "data-bs-target": "",
                                ref: "ligaModal",
                                onClick: ($event: any) => (_ctx.MostrarArchivo(documento.documentoRequisicionPagoId, documento.tipoDocumento))
                              }, _toDisplayString(documento.fechaSubida.substring(0, 10).toLowerCase()), 9, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode("i", {
                            class: "fas fa-times iconoEliminarArchivo",
                            onClick: _withModifiers(($event: any) => (_ctx.EliminarArchivoExistente(documento.documentoRequisicionPagoId)), ["prevent"])
                          }, null, 8, ["onClick"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_ModalDocumento, {
                documentoId: _ctx.documentoId,
                rutaDocumento: _ctx.rutaDocumentoExistente
              }, null, 8, ["documentoId", "rutaDocumento"])
            ])
          ]),
          _createVNode("div", _hoisted_64, [
            _withDirectives(_createVNode("textarea", {
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.observaciones = $event)),
              class: "form-control area-motivo",
              id: "exampleFormControlMotivo",
              rows: "3",
              placeholder: "Escribe tu motivo"
            }, null, 512), [
              [_vModelText, _ctx.observaciones]
            ]),
            _createVNode("button", {
              type: "submit",
              onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.ActualizarEstatus()), ["prevent"])),
              class: "btn btn-primary float-end mt-2",
              style: {"color":"white","border-radius":"7px"},
              id: "btn-Enviar"
            }, " Responder ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_65, [
      _hoisted_66,
      _createVNode("div", _hoisted_67, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bitacora, (bit) => {
          return (_openBlock(), _createBlock("div", {
            class: "col-md-12",
            name: "comentario",
            key: bit.bitacoraEstatusId
          }, [
            _createVNode("p", _hoisted_68, [
              _createTextVNode(_toDisplayString(bit.usuario != null ? bit.usuario.userName : "Desconocido") + " ", 1),
              _createVNode("small", _hoisted_69, _toDisplayString(bit.descripcionRespuesta) + " el " + _toDisplayString(bit.fechaPersonalizada), 1)
            ]),
            _createVNode("div", _hoisted_70, [
              _createVNode("p", _hoisted_71, _toDisplayString(bit.observaciones), 1),
              _createVNode("small", _hoisted_72, _toDisplayString(bit.fechaPersonalizada), 1)
            ]),
            _hoisted_73
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_74, [
        _withDirectives(_createVNode("textarea", {
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.comentario = $event)),
          class: "form-control area-respuesta",
          id: "exampleFormControlTextarea1",
          rows: "3",
          placeholder: "Escribe una respuesta"
        }, null, 512), [
          [_vModelText, _ctx.comentario]
        ]),
        _createVNode("button", {
          onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.EnviarComentario()), ["prevent"])),
          class: "btn btn-primary float-end mt-2",
          style: {"color":"white","border-radius":"7px"}
        }, [
          _hoisted_75,
          _hoisted_76
        ])
      ])
    ])
  ]))
})